import { createReducer, on } from '@ngrx/store'
import { LiberatedAreaActions } from './action-types'
import { PerfectScrollbarActions } from '../../../../../shared/ui/perfect-scrollbar/state/actions-type'
import { StoreKeysEnum } from '../../../../../store/store-keys'

export const initialState = {
    filterCriteria: {
        offset: 0,
        limit: 20,
        sortDir: 'desc',
        sortedBy: 'text',
        text: null,
    },
    itemCollection: null,
    allItemCollection: null
}

export const liberatedAreaReducer = createReducer(
    initialState,
    // =======================
    //  NECESSARY REDUCER TO WORK WITH PERFECT SCROLLBAR
    //  CANT BE MOVED TO EFFECT SINCE IT NEEDS TO RUN AT FIRST BEFORE OTHER EFFECTS
    // =======================
    on(PerfectScrollbarActions.updateOriginFilterCriteria, (state, props): ILiberatedAreaState =>
        props.key === StoreKeysEnum.AdminLiberatedArea ?
            {...state, filterCriteria: { ...state.filterCriteria, ...props.fragment }} : state
    ),
    // =======================
    on(LiberatedAreaActions.resetLiberatedAreaItemCollection, (state): ILiberatedAreaState => {
        return {...state, filterCriteria: { ...initialState.filterCriteria }}
    }),
    on(LiberatedAreaActions.resetLiberatedAreaItemCollection, (state): ILiberatedAreaState => {
        return {...state, itemCollection: { ...initialState.itemCollection }}
    }),
    on(LiberatedAreaActions.setLiberatedAreaItemCollection, (state, props): ILiberatedAreaState => {
        return {...state, itemCollection: props.itemCollection}
    }),
    on(LiberatedAreaActions.setLiberatedAreaFilterCriteria, (state, props): ILiberatedAreaState => {
        return {...state, filterCriteria: props.filterCriteria}
    }),
    on(LiberatedAreaActions.setLiberatedAreaAllItemCollection, (state, props): ILiberatedAreaState => {
        return {...state, allItemCollection: props.allItemCollection}
    }),
    on(LiberatedAreaActions.updateFilterCriteria, (state, props) => {
        const criteria = { ...state.filterCriteria, ...props.filterCriteriaFragment }

        return {...state, filterCriteria: criteria}
    }),
    on(LiberatedAreaActions.updateFilterCriteriaAndFilter, (state, props) => {
        const criteria = { ...state.filterCriteria, ...props.filterCriteriaFragment }

        return {...state, filterCriteria: criteria}
    }),
)

export interface ILiberatedAreaState {
    filterCriteria: ILiberatedAreaFilterCriteria;
    itemCollection: any[];
    allItemCollection: any[];
}

export interface ILiberatedAreaFilterCriteria {
    offset: number;
    limit: number;
    sortDir: string;
    sortedBy: string;
    text: string;
    ukopl?: any;
    pocpl?: any;
}